import React from 'react';
import DialogTitleBase from '@material-ui/core/DialogTitle';

const DialogTitle = (props) => <DialogTitleBase {...props} />;

export default DialogTitle;
